type ID = string | number;

const routes = {
  home: '/',
  audits: '/audits',
  notifications: '/notifications',
  contact: '/kontakt/besprechung',
  account: {
    settings: '/account/settings',
  },
  admin: {
    companies: '/admin/companies',
  },
  company: {
    audits: (id: ID) => `/company/${id}/audits`,
    settings: (id: ID) => `/company/${id}/settings`,
    myCompanySettings: '/company/settings',
    /** Same path; optional query opens Templates tab */
    myCompanySettingsTemplates: '/company/settings?tab=templates',
  },
  dashboard: {
    overview: (auditId: ID) => `/dashboard/${auditId}/overview`,
    settings: (auditId: ID) => `/dashboard/${auditId}/settings`,
    status: (auditId: ID) => `/dashboard/${auditId}/status`,
    meeting: (auditId: ID, id: ID) => `/dashboard/${auditId}/meetings/${id}`,
    meetings: (auditId: ID) => `/dashboard/${auditId}/meetings`,
    request: (auditId: ID, id: ID) => `/dashboard/${auditId}/requests/${id}`,
    requests: (auditId: ID) => `/dashboard/${auditId}/requests`,
    document: (auditId: ID, id: ID) => `/dashboard/${auditId}/documents/${id}`,
    documents: (auditId: ID) => `/dashboard/${auditId}/documents`,
    dataAnalysis: (auditId: ID) => `/dashboard/${auditId}/data-analysis`,
    // A single saved view is selected via the `?view=` query param on the
    // data-analysis page (there is no per-view path segment); see useActiveView.
    dataAnalysisView: (auditId: ID, viewId: ID) =>
      `/dashboard/${auditId}/data-analysis?view=${viewId}`,
    // A Finding is addressed the same way (`?finding=`); the server registers a pasted
    // URL of either shape as a reference (0.54.0). Whether `?finding=` stays a param or
    // becomes a route is an open product question — one helper, so the answer lands once.
    // ⚠ NO PAGE READS IT YET: a Finding opens on the data page with #636, and until then
    // backlinks to a Finding render disabled rather than link here.
    dataAnalysisFinding: (auditId: ID, findingId: ID) =>
      `/dashboard/${auditId}/data-analysis?finding=${findingId}`,
    roleAdd: (auditId: ID) => `/dashboard/${auditId}/role/add`,
    teamRoleEdit: (auditId: ID, idRole: ID) => `/dashboard/${auditId}/team-role/edit/${idRole}`,
  },
  public: {
    documentView: (id: ID, accessCode: string) => `/public/document/${id}/${accessCode}/view`,
  },
  auth: {
    login: '/login',
    forgotPassword: '/login/email',
    forgotPasswordSent: '/login/email/send',
    setPassword: '/login/new-password',
    phoneLogin: '/login/phone',
    phoneVerification: '/login/phone/sms',
  },
};

export default routes;
